/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Localized displayed resources for Spanning Backup for Salesforce
 */

const enMessages = require('./en');

// We don't want prettier wrapping all these lines or changing the single quotes to double quotes
// when there's an escaped quote in the string.
// prettier-ignore
//eslint-disable-next-line no-global-assign,no-implicit-globals,no-native-reassign
SBSF = {};
SBSF.messages = enMessages;

module.exports.en = SBSF.messages;
